module.exports = __webpack_public_path__ + "static/media/bleeding2.25211da9.png";